/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBookingSlotsQueryResponse, GetApiBookingSlotsQueryParams } from "../entities/GetApiBookingSlots";

function getGetApiBookingSlotsUrl() {
  const res = { method: 'GET', url: `/api/booking/slots` as const }
  return res
}

/**
 * @description Получить список доступных слотов 30 минут
 * @summary Получить доступные слоты
 * {@link /api/booking/slots}
 */
export async function getApiBookingSlots(params: GetApiBookingSlotsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBookingSlotsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetApiBookingSlotsUrl().url.toString(), params, ... requestConfig })
  return res.data
}